const G = "#b8960c";

const PROJECTS = [
  { name: "FanzOut", desc: "Your city, your people, your events — discover concerts, festivals, sports events, local meetups, and places to visit all in one app. Organise your own events, connect with people around you, and never experience your city alone again.", tags: ["Sports", "Community", "Events", "Meetups"], icon: "🎉", link: "https://fanzout.com/" },
  { name: "Naija Mega Food", desc: "An online food store bringing authentic African and Nigerian cuisine to Germany — order your favourite meals and groceries delivered straight to your door.", tags: ["Food", "African Cuisine", "Delivery"], icon: "🍽️", link: "https://naijamegafood.de/" },
  { name: "IT Automation Suite", desc: "A collection of scripts that automate repetitive IT tasks — saving time, reducing human error, and keeping systems running smoothly without manual intervention.", tags: ["Automation", "IT Ops", "Productivity"], icon: "⚙️", link: null },
  { name: "Knowledge Base Platform", desc: "An internal self-service hub where employees find answers to common IT questions instantly — reducing support tickets and empowering teams to solve problems independently.", tags: ["Self-Service", "IT Support", "Documentation"], icon: "📚", link: null },
  { name: "Device Lifecycle System", desc: "A system that manages company devices from day one to retirement — ensuring every employee has a working, secure device and that nothing falls through the cracks.", tags: ["Device Management", "IT Ops", "Security"], icon: "💻", link: null },
];

function GoldTag({ children }) {
  return <span className="inline-block px-2 py-0.5 text-[11px] border rounded-sm mr-1 mt-1 font-medium" style={{ borderColor: G + "44", color: G, background: G + "11" }}>{children}</span>;
}

function SectionHeader({ label, title }) {
  return (
    <div className="mb-4">
      <p className="text-xs tracking-[0.25em] uppercase mb-1 font-semibold" style={{ color: G }}>{label}</p>
      <h2 style={{ fontFamily: 'Playfair Display, serif' }} className="text-3xl sm:text-4xl font-black text-white">{title}</h2>
      <div className="w-10 h-0.5 mt-2" style={{ background: G }} />
    </div>
  );
}

export default function Projects({ refs }) {
  return (
    <section id="Projects" ref={el => (refs.current["Projects"] = el)} className="py-8">
      <SectionHeader label="Portfolio" title="Projects" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {PROJECTS.map(p => (
          <div key={p.name} className="border border-white/8 rounded-sm p-4 sm:p-5 hover:border-yellow-600/30 transition-all" style={{ background: "#1a1a1a" }}>
            <div className="text-2xl mb-2">{p.icon}</div>
            <h3 style={{ fontFamily: 'Playfair Display, serif' }} className="text-white font-bold text-base sm:text-lg mb-1">{p.name}</h3>
            <p className="text-xs text-gray-500 leading-relaxed mb-3">{p.desc}</p>
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div>{p.tags.map(t => <GoldTag key={t}>{t}</GoldTag>)}</div>
              {p.link && (
                <a href={p.link} target="_blank" rel="noreferrer"
                  className="text-[11px] font-bold tracking-widest uppercase px-3 py-1.5 rounded-sm transition-all"
                  style={{ background: G, color: "#0f0f0f" }}>
                  Visit →
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
